import React, { useEffect, useState } from "react";
import SEO from "../components/SEO";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    parentName: "",
    childName: "",
    phone: "",
    email: "",
    course: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 80,
      easing: "ease-in-out",
    });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { parentName, childName, phone, email, course, message } = formData;

    const whatsappMessage = `
Hello, I would like to enquire about SIP Abacus.

Parent Name: ${parentName}
Child Name: ${childName}
Phone: ${phone}
Email: ${email}
Interested Course: ${course}

Message: ${message}
`;

    const encodedMessage = encodeURIComponent(whatsappMessage);

    const whatsappNumber = "919989284428"; // without + sign

    const url = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

    window.open(url, "_blank");
  };

  return (
    <>
    <SEO
      title="Contact SIP Abacus Malkajgiri | Phone, Address & Enquiry Form"
      description="Contact SIP Abacus Malkajgiri for course enquiries, demo sessions & admissions. Visit us at Bhavani Nagar, Malkajgiri, Hyderabad 500047 or call +91 99892 84428. Send us an enquiry today!"
      keywords="contact SIP Abacus Malkajgiri, SIP Abacus phone number, SIP Abacus address, abacus classes enquiry Malkajgiri, SIP Abacus Bhavani Nagar, abacus admission enquiry Hyderabad, SIP Abacus location, abacus demo class booking, abacus classes near HDFC Bank Malkajgiri, SIP Abacus working hours, abacus course enquiry, SIP Abacus email, children abacus enrollment Hyderabad"
      canonicalPath="/contact"
    />
    <section className="page-section contact">
      <div className="container">
        <div className="contact-header" data-aos="fade-up">
          <h1 className="page-title">Contact Us</h1>
          <h2 className="page-subtitle">We would love to hear from you</h2>
          <p className="contact-intro">
            Have questions about our abacus programs, batches, or admissions?
            Reach out to us and we’ll be happy to help.
          </p>
        </div>

        <div className="contact-wrapper">
          {/* LEFT INFO CARD */}
          <div className="contact-info-card" data-aos="fade-right">
            <h3>Get in Touch</h3>
            <p className="info-text">
              Connect with SIP Abacus for course details, demo sessions, fee
              information, and admissions support.
            </p>

            <div className="info-list">
              <div className="info-item">
                <div className="info-icon"><FaPhoneAlt /></div>
                <div>
                  <span>Phone</span>
                  <p>+91 99892 84428</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon"><FaEnvelope /></div>
                <div>
                  <span>Email</span>
                  <p>info@sipabacusmalkajgiri.com</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon"><FaMapMarkerAlt /></div>
                <div>
                  <span>Address</span>
                  <p>VS Buildings, 3rd floor , 
Building number 2-8,
Plot number 30,
Bhavani nagar, 
Beside HDFC BANK, 
Malkajgiri ,500047</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon"><FaClock /></div>
                <div>
                  <span>Working Hours</span>
                  <p>Tue - Sat | 4:00 PM - 8:00 PM</p>
                  <p>Sunday | 9:00 AM - 1:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT FORM CARD */}
          <div className="contact-form-card" data-aos="fade-left">
            <h3>Send an Enquiry</h3>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Parent Name</label>
                  <input
                    type="text"
                    id="parentName"
                    value={formData.parentName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Child Name</label>
                  <input
                    type="text"
                    id="childName"
                    value={formData.childName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Interested Course</label>
                <select
                  id="course"
                  value={formData.course}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a course</option>
                  <option value="Abacus Beginner">Abacus Beginner / Junior</option>
                  <option value="Abacus Advanced">Abacus Advanced</option>
                  <option value="Foundation">Foundation</option>
                  <option value="Grand Master">Grand Master</option>
                  <option value="Demo Session">Demo Session</option>
                </select>
              </div>

              <div className="form-group">
                <label>Message</label>
                <textarea
                  id="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

              <button type="submit" className="contact-btn">
                Send Enquiry
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}

export default Contact;